module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0 15px"
    }
  }, [_c('div', {
    attrs: {
      "id": "approveState"
    }
  }, [(!_vm.stateList || _vm.stateList.length == 0) ? [_c('div', {
    staticClass: "empty-state"
  }, [_vm._v("\n        " + _vm._s(_vm.$tx("暂无审批信息", "common.noApprovalInfo")) + "\n      ")])] : [_c('div', {
    style: ({
      width: _vm.stateList.length * 200 + 'px'
    })
  }, _vm._l((_vm.stateList), function(state, index) {
    return _c('div', {
      key: state.new_flowapproval_stepsId
    }, [_c('div', {
      staticClass: "node"
    }, [_c('i', {
      staticClass: "node-icon",
      class: {
        'icon-approving': state.new_status === 1,
        'icon-approved': state.new_status === 2,
        'icon-submit': state.new_status === 0,
      }
    }), _vm._v(" "), _c('ul', [_c('li', {
      staticClass: "owner"
    }, [_vm._v(_vm._s(state.new_userName))]), _vm._v(" "), _c('li', {
      staticClass: "date"
    }, [_vm._v(_vm._s(state.new_date))])])]), _vm._v(" "), (index !== _vm.stateList.length - 1) ? _c('div', {
      staticClass: "proce"
    }, [_c('span', [_vm._v("- - - - - - - - - - -")])]) : _vm._e()])
  }), 0)]], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "approveTrack"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$tx('历史记录', 'common.historyRecord')))]), _vm._v(" "), _c('ul', _vm._l((_vm.trackList), function(track, index) {
    return _c('li', {
      key: track.new_flowapproval_logId,
      class: {
        last: index === _vm.trackList.length - 1
      }
    }, [_c('div', {
      staticStyle: {
        "margin-top": "0"
      }
    }, [_c('i', {
      staticClass: "node-icon",
      class: {
        first: index === 0
      }
    }), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(track.new_date))]), _vm._v(" "), _c('span', {
      staticClass: "action"
    }, [_vm._v("[" + _vm._s(track.new_actionName) + "]")]), _vm._v(" "), _c('span', {
      staticClass: "step"
    }, [_vm._v(_vm._s(track.new_stepName))]), _vm._v(" "), _c('span', {
      staticClass: "owner"
    }, [_vm._v(_vm._s(track.new_userName))])]), _vm._v(" "), _c('div', {
      staticClass: "memo"
    }, [_c('span', [_vm._v(_vm._s(track.new_memo))])])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4199e412"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/approval/src/progress.vue
// module id = 2129
// module chunks = 137